import { common, lightBlue } from '@material-ui/core/colors';
import { fade } from '@material-ui/core/styles/colorManipulator';

const opacity = {
    black04: fade( common.black, 0.04 ),
    black08: fade( common.black, 0.08 ),
    black14: fade( common.black, 0.14 ),
    black24: fade( common.black, 0.24 ),
    black38: fade( common.black, 0.38 ),
    black60: fade( common.black, 0.60 ),
    black87: fade( common.black, 0.87 ),
    invisible: fade( common.black, 0 ),
    primary08: fade( lightBlue[600], 0.08 ),
};
export default opacity;
